import { AccessibleStatus, AccessibleWarningStatus, CanceledStatus, CancelingStatus, ClusteredStatus, CompleteMarkedStatus, CompleteStatus, CompleteWithWarningsStatus, ConditionalCompleteStatus, ConditionalStatus, DebuggerChangeIndicator, DebugStatus, DefaultStatus, DisconnectedStatus, EmbeddedStatus, ErrorStatus, FavoritedIndicator, FlaggedStatus, HiddenStatus, HistoricalStatus, ImportantStatus, IncompleteInProgressStatus, IncompleteMarkedStatus, IncompleteStatus, IncompleteWarningStatus, InformationMarkedStatus, InformationStatus, InsightFoundStatus, InsightStatus, InvalidMarkedStatus, InvalidStatus, LockedStatus, LowPriorityStatus, MediumPriorityStatus, MergedStatus, NeutralStatus, NewStatus, OnDemandStatus, OutOfSyncStatus, PausedStatus, PausedWithErrorsStatus, ProgressStatus, ReadOnlyStatus, RequiredStatus, RevertedStatus, ReviewStatus, ReviewWithWarningsStatus, ScheduledStatus, StoppedStatus, StoppingStatus, SubmittedStatus, SubmittedWithErrorsStatus, Superuser, TimedOutStatus, TrendDownStatus, TrendNoChangeStatus, TrendUpStatus, VisibleStatus, WarningStatus } from '@sas/react-svg';
export const StatusIconMap = {
  AccessibleStatus,
  AccessibleWarningStatus,
  CanceledStatus,
  ClusteredStatus,
  CompleteStatus,
  CompleteWithWarningsStatus,
  ConditionalCompleteStatus,
  ConditionalStatus,
  DebuggerChangeIndicator,
  DebugStatus,
  DefaultStatus,
  DisconnectedStatus,
  EmbeddedStatus,
  ErrorStatus,
  FlaggedStatus,
  HiddenStatus,
  HistoricalStatus,
  ImportantStatus,
  IncompleteInProgressStatus,
  IncompleteStatus,
  IncompleteWarningStatus,
  InformationStatus,
  InsightFoundStatus,
  InsightStatus,
  InvalidStatus,
  LockedStatus,
  LowPriorityStatus,
  MediumPriorityStatus,
  MergedStatus,
  NeutralStatus,
  NewStatus,
  OnDemandStatus,
  OutOfSyncStatus,
  PausedStatus,
  ProgressStatus,
  ReadOnlyStatus,
  RequiredStatus,
  RevertedStatus,
  ReviewStatus,
  ScheduledStatus,
  StoppedStatus,
  StoppingStatus,
  SubmittedStatus,
  Superuser,
  TrendDownStatus,
  TrendNoChangeStatus,
  TrendUpStatus,
  VisibleStatus,
  WarningStatus,
  FavoritedIndicator,
  CancelingStatus,
  CompleteMarkedStatus,
  IncompleteMarkedStatus,
  InformationMarkedStatus,
  PausedWithErrorsStatus,
  InvalidMarkedStatus,
  ReviewWithWarningsStatus,
  SubmittedWithErrorsStatus,
  TimedOutStatus
};
//# sourceMappingURL=StatusIconsList.js.map